import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { Button } from 'primeng/button';
import { Paginator } from 'primeng/paginator';
import { Card } from 'primeng/card';
import { RulesApi } from '../../../../../shared/services/api/rules.api';
import {
  Regulamin,
  RegulaminHistory,
} from '../../../../../shared/models/regulamin';
import { TableBaseAbstractComponent } from '../../../../../shared/components/table-base-abstract.component';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, Observable, of } from 'rxjs';
import { TableResponse } from '../../../../../shared/models/table-response';
import { TableRequestData } from '../../../../../shared/models/table/table-request-param';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AdminPanelRuleDetailsHistoryModal } from '../admin-panel-rule-details-history-modal/admin-panel-rule-details-history-modal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RuleEventType } from '../../../../../shared/enums/rule-event-type.enum';
import { RuleObjectTypes } from '../../../../../shared/enums/rule-object-types.enum';
import { InputText } from 'primeng/inputtext';
import { EnumLabelPipe } from '../../pipes/event-type-label.pipe';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-admin-panel-rule-details-history',
  imports: [
    TableModule,
    DatePicker,
    Select,
    Button,
    Paginator,
    Card,
    FormsModule,
    DatePipe,
    InputText,
    EnumLabelPipe,
    Tooltip,
  ],
  templateUrl: './admin-panel-rule-details-history.html',
  styleUrl: './admin-panel-rule-details-history.scss',
  providers: [RulesApi],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelRuleDetailsHistory
  extends TableBaseAbstractComponent<RegulaminHistory>
  implements OnInit
{
  @ViewChild('table') override tableRef!: Table;

  readonly #ruleApi = inject(RulesApi);
  readonly #dialogService = inject(DialogService);
  readonly #destroyRef = inject(DestroyRef);
  readonly rule = input<Regulamin>();
  public ruleEventType = RuleEventType;
  public objectType = RuleObjectTypes;
  #ruleId: number | null = null;

  protected tableFilters = {
    eventDate: '',
    eventObject: null,
    eventType: null,
    eventAuthor: '',
  };

  protected readonly ruleTypeOptions = Object.entries(RuleEventType).map(
    ([key, value]) => ({
      label: value,
      value: key,
    }),
  );

  protected readonly ruleObjectOptions = Object.entries(RuleObjectTypes).map(
    ([key, value]) => ({
      label: value,
      value: key,
    }),
  );

  constructor() {
    super();
  }

  ngOnInit(): void {
    const parsedId = this.rule()?.id ? Number(this.rule()?.id) : NaN;
    this.#ruleId = Number.isFinite(parsedId) ? parsedId : null;
  }

  protected override apiCall$ = (
    params: TableRequestData,
  ): Observable<TableResponse<RegulaminHistory>> => {
    return this.#ruleApi.getRuleHistory$(params, this.#ruleId);
  };


  //   protected override apiCall$ = (
  //     params: TableRequestData,
  //   ): Observable<TableResponse<RegulaminHistory>> => {
  //     return of({
  //       content: [],
  //       page: {
  //         size: 0,
  //         number: 0,
  //         totalElements: 0,
  //         totalPages: 0,
  //       },
  //     });
  //   };

  protected onFilterChangeMobile(
    target: EventTarget | null,
    field: string,
  ): void {
    this.onPrimeFilterChangeMobile(target as any, field);
  }

  protected showDetails(entry: RegulaminHistory): void {
    const ruleDetailsDialog = this.#dialogService.open(
      AdminPanelRuleDetailsHistoryModal,
      {
        header: 'Podgląd zdarzenia regulaminu',
        closable: true,
        modal: true,
        closeOnEscape: true,
        dismissableMask: true,
        width: '900px',
        breakpoints: {
          '960px': '90vw',
          '640px': '90vw',
        },
        inputValues: { entry },
      },
    );

    ruleDetailsDialog?.onClose
      .pipe(filter(Boolean), takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  protected clearFilters(): void {
    this.tableFilters = {
      eventDate: '',
      eventObject: null,
      eventType: null,
      eventAuthor: '',
    };
    this.resetFilters();
  }
}
